// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2cjk1","tab":"Tabs_tab__BBzR1","tabActive":"Tabs_tabActive__2OW7N"};